// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

// account
function login(params) {
    const payload = {
        ...params,
        platform: 'web',
    };

    const baseUrl = config.RDPMS_API_URLS + '/user/login';
    return api.create(`${baseUrl}`, payload);
}

function logout(params) {
    const payload = {
        ...params,
        platform: 'web',
    };

    const baseUrl = config.RDPMS_API_URLS + '/user/logout';
    return api.create(`${baseUrl}`, payload);
}

function signup(params) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params) {
    // const baseUrl = '/forget-password/';
    const baseUrl = config.RDPMS_API_URLS + '/user/forgot/password';
    return api.create(`${baseUrl}`, params);
}

function forgotPasswordConfirm(params) {
    const baseUrl = '/password/reset/confirm/';
    return api.create(`${baseUrl}`, params);
}

function mobileVerification(params) {
    const payload = {
        ...params,
        platform: 'web',
    };
    const baseUrl = config.RDPMS_API_URLS + '/user/mobile/verify';
    return api.create(`${baseUrl}`, payload);
}

function userVerification(params) {
    const payload = {
        ...params,
        platform: 'web',
    };
    const baseUrl = config.RDPMS_API_URLS + '/user/verify';
    return api.create(`${baseUrl}`, payload);
}

export { login, logout, signup, forgotPassword, forgotPasswordConfirm, mobileVerification, userVerification };
